import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bed"><path d="M4 5.75C4 4.7835 4.7835 4 5.75 4H11.25V9.5H4V5.75Z" fill="currentColor"/><path d="M12.75 9.5V4H18.25C19.2165 4 20 4.7835 20 5.75V9.5H12.75Z" fill="currentColor"/><path d="M22 12.75C22 11.7835 21.2165 11 20.25 11H3.75C2.7835 11 2 11.7835 2 12.75V16.25C2 17.2165 2.7835 18 3.75 18H4V19.25C4 19.6642 4.33579 20 4.75 20C5.16421 20 5.5 19.6642 5.5 19.25V18H18.5V19.25C18.5 19.6642 18.8358 20 19.25 20C19.6642 20 20 19.6642 20 19.25V18H20.25C21.2165 18 22 17.2165 22 16.25V12.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBed;
